import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { ThirdPartyPayoff } from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface SetThirdPartyPayoffPayoffAmountRequest {
    engagementId: number;
    tableRowId: number;
    payoffAmount: number | null;
}

export const SetThirdPartyPayoffPayoffAmount = createAsyncThunk(
    'flowOfFunds/setThirdPartyPayoffPayoffAmount',
    async (params: SetThirdPartyPayoffPayoffAmountRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.put(
                `/api/flowOfFunds/${params.engagementId}/thirdPartyPayoffs/rows/${params.tableRowId}/payoffAmount`,
                {
                    payoffAmount: params.payoffAmount,
                }
            );

            if (response.status !== 200) {
                throw new Error('Failed to save the pay-off amount');
            }

            return response.data as ThirdPartyPayoff;
        } catch (error) {
            createNotification('Could not save the pay-off amount.', 'error');
            throw error;
        }
    }
);
